// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.graph-title {
    background: #fff;
    font-size: 1.1em;
    font-weight: bold;
    field-sizing: content;
    min-width: 10em;
    border: none;
}

.graph-title:hover {
    background: #ffeded;
}

.graph-metadata {
    background: #fff;
    max-width: 20em;
    word-break: break-all;
}`, "",{"version":3,"sources":["webpack://./src/TreeLabel.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,qBAAqB;AACzB","sourcesContent":[".graph-title {\n    background: #fff;\n    font-size: 1.1em;\n    font-weight: bold;\n    field-sizing: content;\n    min-width: 10em;\n    border: none;\n}\n\n.graph-title:hover {\n    background: #ffeded;\n}\n\n.graph-metadata {\n    background: #fff;\n    max-width: 20em;\n    word-break: break-all;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
